import React from 'react';
import TableCellMaterial from '@material-ui/core/TableCell';
import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';

const useStyles = makeStyles({
  td: {
    lineHeight: '1rem',
    padding: '0.5rem 1rem',
    fontSize: '0.8rem',
    height: '44px',
    border: 0,
    fontWeight: 500
  }
});

interface TableHeadProps {
  children?: any;
  width?: string;
  className?: string;
  onClick?: () => void;
  style?: any;
  colSpan?: number;
  id?: string;
}

const TableCell = ({
  children,
  width,
  className,
  onClick,
  style,
  colSpan,
  id
}: TableHeadProps) => {
  const classes = useStyles();
  return (
    <TableCellMaterial
      id={id}
      colSpan={colSpan}
      style={{ width: width, minWidth: width, maxWidth: width, ...style }}
      className={classnames(classes.td, className && className)}
      onClick={onClick}
    >
      {children}
    </TableCellMaterial>
  );
};

export default TableCell;
